var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_77_58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6889 12.3888L12.8901 0.380076C12.4354 -0.126692 11.5619 -0.126692 11.1071 0.380076L0.308346 12.3888C0.152911 12.5612 0.0508845 12.7751 0.014672 13.0045C-0.0215404 13.2339 0.00962142 13.4689 0.104369 13.6809C0.296347 14.1144 0.7259 14.393 1.19985 14.393H3.59958V22.7991C3.59958 23.1176 3.72599 23.4231 3.95101 23.6483C4.17603 23.8735 4.48122 24 4.79944 24H8.39904C8.71727 24 9.02246 23.8735 9.24748 23.6483C9.47249 23.4231 9.59891 23.1176 9.59891 22.7991V17.9956H14.3984V22.7991C14.3984 23.1176 14.5248 23.4231 14.7498 23.6483C14.9748 23.8735 15.28 24 15.5982 24H19.1978C19.5161 24 19.8213 23.8735 20.0463 23.6483C20.2713 23.4231 20.3977 23.1176 20.3977 22.7991V14.393H22.7974C23.0298 14.394 23.2574 14.3273 23.4526 14.2011C23.6478 14.0748 23.802 13.8945 23.8965 13.682C23.991 13.4695 24.0217 13.2341 23.9848 13.0045C23.948 12.7749 23.8452 12.5609 23.6889 12.3888Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_77_58"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterHome);
export default __webpack_public_path__ + "static/media/footer_home.4aa58fee5f725c34c7e852152c6e4d5b.svg";
export { ForwardRef as ReactComponent };